import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ComparacaoContratoIw } from './ComparacaoContratoIw';

/**
 * Parametrização (`TP-051` T10/T11, `TP-071` T11 — ponto 1 do motor): o
 * contrato lado a lado com a tabela de preços e o de-para do IW, e os
 * vínculos confirmados na mesma tabela, sem sair da tela de Contratos.
 */
export function PainelDeParametrizacao({ contratoId }: { contratoId: string }): React.JSX.Element {
  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h2">Contrato × IW</Typography>
      </Box>

      <ComparacaoContratoIw contratoId={contratoId} />
    </Stack>
  );
}
